<template>
    <div class="store-qr-code">
        <div v-if="QRCodeUrl && loadingDataFlag"
            class="qr-code-wrapper"
            @touchstart="communityScan"
            @touchmove.prevent>
            <div class="group">
                <div class="avatar">
                    <img :src="groupAvatar"
                        alt="">
                </div>
                <div class="group-title ellipsis">{{ groupTitle }}</div>
            </div>
            <div class="qr-code">
                <img :src="QRCodeUrl"
                    alt="">
            </div>
            <div class="tips">{{ QRCodeTips }}</div>
        </div>
        <div v-if="!loadingDataFlag"
            class="no-data">
            页面加载失败，请稍后重试
        </div>
    </div>
</template>
<script>
import { Dialog, Toast } from 'vant';
import { wxUserLogin, updateUserInfoCache } from '../../../utils/comUtils';
import utils from '../../../utils/comUtils';

export default {
  data() {
    return {
      groupTitle: '',
      QRCodeTips: '长按二维码识别加入群聊',
      QRCodeUrl: '',
      groupAvatar: '',
      storeCode: '', // 门店编码
      source: 'Hihonor', // 端侧来源，区分Myhonor、荣耀商城和Hihonor
      wxLoginCode: '', // 微信登录code
      loadingDataFlag: true, // 加载数据标识，true：加载成功，false：加载失败
      scene: '', // 跳转场景，1: 小程序门店详情, 2: 小程序门店列表, 3: 小程序订单详情
      defaultGroupAvatar: 'static/runtime/images/magic/default-group-avatar-new.png',
    };
  },
  created() {
    const query = this.$route.query;
    if (query) {
      this.storeCode = query.storeCode || '';
      this.wxLoginCode = query.wxLoginCode || '';
      this.source = query.source || 'Hihonor';
      this.scene = query.scene || '';
    } else {
      Dialog.alert({
        message: `链接传参为空`,
      });
      this.loadingDataFlag = false;
      return;
    }
    sessionStorage.setItem('loginType', 'wechat');
    // 若已存在用户信息，说明登录过了，无需再次登录
    const userInfo = sessionStorage.getItem('userInfo');
    if (userInfo && Object.keys(userInfo).length > 0) {
      this.getPageInfo();
    } else {
      wxUserLogin(this.wxLoginCode)
        .then((res) => {
          this.getPageInfo();
        })
        .catch((err) => {
          Dialog.alert({
            message: err,
          });
        });
    }
    // 埋码上报-针对点击按钮
    this.reportBut(this.scene);
    // 埋码上报-针对进入该页面
    this.reportPage();
  },
  methods: {
    /**
     * 查询页面信息，如入群二维码，群头像，群名称等
     */
    getPageInfo() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      this.$api.get({
        sc: 'mobileMarketing',
        url: `/activityclubgroupmain/getClubInfoByStoreCode/${this.storeCode}`,
        params: {},
        success: (res) => {
          Toast.clear();
          if (res.code === 200) {
            const data = res.result || '';
            if (data) {
              this.QRCodeUrl = data.qrcode;
              this.groupTitle = data.nickname;
              this.groupAvatar = data.avatar || this.defaultGroupAvatar;
              this.title = data.storeName;
              // 设置H5页面title
              document.title = this.title;
              this.loadingDataFlag = true;
            } else {
              this.loadingDataFlag = false;
            }
          } else {
            this.loadingDataFlag = false;
            Dialog.alert({
              message: res.message || '获取页面信息失败',
            });
          }
        },
        failure: (err) => {
          this.loadingDataFlag = false;
          Toast.clear();
          const data = (err.response && err.response.data && err.response.data.result) || '';
          const status = err.response && err.response.status;
          // 用户信息过期，清空缓存
          if (data === 'access_token网关校验不通过!' || status === 401) {
            updateUserInfoCache();
          }
          Dialog.alert({
            message: data ? '登录过期，请重新进入' : '网络不给力，请稍后重试！',
          });
        },
      });
    },
    // 埋码上报-针对点击按钮 4是我的荣耀首页零售卡片，我的荣耀侧该入口暂时屏蔽
    reportBut(scene) {
      let code = '';
      let name = '';
      switch (scene) {
        case '1':
          code = '600040002';
          name = '小程序门店详情拉起福利入群';
          break;
        case '2':
          code = '600040003';
          name = '小程序门店列表拉起福利入群';
          break;
        case '3':
          code = '600040004';
          name = '小程序订单详情拉起福利入群';
          break;
        case '5':
          code = '500090002';
          name = '我的荣耀门店详情拉起福利入群';
          break;
        case '6':
          code = '500090001';
          name = '我的荣耀门店列表拉起福利入群';
          break;
        case '7':
          code = '500090004';
          name = '我的荣耀订单详情拉起福利入群';
          break;
        case '8':
          code = '500090003';
          name = '我的荣耀商品详情(直营店)拉起福利入群';
          break;
        case '9':
          code = '500100001';
          name = '荣耀商城门店列表拉起福利入群';
          break;
      }
      const params = {
        actionCode: code,
        actionName: name,
        content: {
          source: this.source,
          channelCode: this.storeCode,
        },
      };
      utils.handleBatchReport(null, params);
    },
    // 埋码上报-针对进入该页面
    reportPage() {
      const params = {
        actionCode: '500090005',
        actionName: '进入福利入群页面',
        content: {
          source: this.source,
          channelCode: this.storeCode,
        },
      };
      utils.handleBatchReport(null, params);
    },
    // 社群扫码
    communityScan() {
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketing',
        url: 'miniMemberAndCommunityStatistics/communityScan',
        params: {
          activityCode: '',
          //渠道 1、活力魔方活动 2、门店WIFI 3、企业微信小程序 4、荣耀+app（店员开单） 5、门店扫描 6、微信小程序 7、支付宝小程序 8、myHonor侧跳转过来9、门店游戏墙活动 10、导购线索 11、荣耀商城
          channel: this.source === 'Hihonor' ? '6' : this.source === 'honorMall' ? '11' : '8', // 目前只有微信小程序、myHonor和荣耀商城点击福利入群后跳转过来
          channelCode: this.storeCode,
          // 接口增加来源字段
          source: this.scene,
        },
        success: (r) => {
          console.log('识别社群二维码', r);
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.store-qr-code {
  width: 100vw;
  height: 100vh;
  background-color: #f4f6fe;
  padding: 6.4vw 5.33333vw calc(19.73333vw + env(safe-area-inset-bottom));
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  .qr-code-wrapper {
    margin: auto;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0.8vw 1.6vw 0 rgba(0, 0, 0, 0.05);
    border-radius: 1.6vw;
    padding: 5.33333vw 5.33333vw 8vw;
    .group {
      text-align: left;
      display: flex;
      align-items: center;
      font-size: 4.26667vw;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.85);
      .avatar {
        width: 10.66667vw;
        height: 10.66667vw;
        border-radius: 1.06667vw;
        margin-right: 2.66667vw;
        img {
          width: 10.66667vw;
          height: 10.66667vw;
        }
      }
      .group-title {
        font-weight: bold;
      }
    }
    .qr-code {
      margin-top: 10.66667vw;
      position: relative;
      img {
        width: 57.33333vw;
        height: 57.33333vw;
        vertical-align: middle;
        border-style: none;
      }
    }
    .tips {
      font-size: 3.5vw;
      margin-top: 5.33333vw;
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .no-data {
    font-size: 4vw;
    color: rgba(0, 0, 0, 0.45);
  }
  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/storeEntryGroup/storeQrCode.vue